'use client';
import { jsx } from 'react/jsx-runtime';
import { useGetIntl } from '@repo/i18n/intl/client';
import { z } from 'zod';
import { PHASE_EXPORT, PHASE_PRODUCTION_BUILD, PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER, PHASE_TEST, PHASE_INFO } from 'next/constants';

const variables = {
    ANALYZE: process.env.ANALYZE,
    NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    NEXT_PUBLIC_PROTOCOL: process.env.NEXT_PUBLIC_PROTOCOL,
    NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NODE_ENV: process.env.NODE_ENV,
    PHASE: process.env.PHASE
};
const publicVariablesSchema = z.object({
    NEXT_PUBLIC_DEFAULT_LOCALE: z.string(),
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string(),
    NEXT_PUBLIC_PROTOCOL: z.union([
        z.literal("http"),
        z.literal("https")
    ]),
    NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: z.string(),
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: z.string(),
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: z.string(),
    NEXT_PUBLIC_SITE_NAME: z.string(),
    NODE_ENV: z.enum([
        "development",
        "production",
        "test"
    ]),
    PHASE: z.enum([
        PHASE_EXPORT,
        PHASE_PRODUCTION_BUILD,
        PHASE_PRODUCTION_SERVER,
        PHASE_DEVELOPMENT_SERVER,
        PHASE_TEST,
        PHASE_INFO
    ])
});
const privateVariablesSchemaClient = z.object({
    ANALYZE: z.undefined()
});
const privateVariablesSchemaServer = z.object({
    ANALYZE: z.stringbool().optional()
});
const envSchema = z.intersection(publicVariablesSchema, typeof window === "undefined" ? privateVariablesSchemaServer : privateVariablesSchemaClient);
const env = envSchema.parse(variables);

function Impressum({ className, dictionaryPromise, lang }) {
    const intl = useGetIntl({
        dictionaryPromise,
        lang
    });
    const currentYear = new Date().getFullYear();
    return /*#__PURE__*/ jsx("span", {
        className: className,
        children: intl.formatMessage({
            id: "43LrwP",
            defaultMessage: "© {currentYear} {siteName}. All rights reserved.",
            description: "Text for an impressum in the GlobalFooter component"
        }, {
            currentYear,
            siteName: env.NEXT_PUBLIC_SITE_NAME
        })
    });
}

export { Impressum };
